<script>
  import { onMount } from 'svelte';
  import {ficDeMenu} from "../modules/ficMenu.js";

 
  export let project_id;
  console.log("project_id:",project_id);


  let vsPrefix = process.env.VIS_SITE_PREFIX;
  let outBod = document.getElementById("outerBody");
  outBod.classList.add("map");
  outBod.classList.remove("default");

  let loginLink ;
  let logInElement = "<a href='https://msc.fic.li' role='link' title='Sign in to your account'>Sign in</a> ";
  let mounted = false;

  onMount(async  () =>{
   
      ficDeMenu();

  });

  loginLink = document.getElementById("loginlink");


//when local
let projLink =vsPrefix+"/"+project_id+"/network";
//when not 
//let projLink =API_SERVER_URL+"/"+project_id+"/network";

console.log("projLink ",projLink)

</script>

<div class="map">
    <div class="fic--map">
       
    </div>
</div>


